import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { HttpClient } from "../../../../shared/services/http-client";

export interface IGoogleAudience {
  name: string;
  audienceId: number;
  parentId: number;
  children?: IGoogleAudience[];
}

export interface IGoogleAudienceData {
  tree: IGoogleAudience[];
  flat: IGoogleAudience[];
}

@Injectable()
export class GoogleTargetingService {
  constructor(private http: HttpClient) {}

  getGoogleTargeting(): Observable<IGoogleAudienceData> {
    return this.http.get(`google/targeting`).pipe(map(({ body }) => body));
  }
}
